import Select from "react-select";
import React, { useEffect, useState } from "react";
import "./SearchSelect.css";
import { Form } from "react-bootstrap";
export default function SearchSelect(props) {

  const [focus, setFocus] = useState(false);
  const alphanumericWithoutSpaceRegex = /^[a-zA-Z0-9]*$/;
  const specialCharacterRegex = /[!@#$%^&*()]/;
  let options = [];

  props?.data?.map((item, index) => {
    let option = {};
    if (props?.isPatternApplicable) {
      let fields = [{ propField: "valueField", optionField: "value" },
      { propField: "labelField", optionField: "label" }]
      let prevPattern = "";
      let prevValue = "";

      for (let fld of fields) {
        let fieldData = props[fld.propField];
        if (fieldData === prevPattern) {
          option[fld.optionField] = prevValue;
          break
        }
        prevPattern = fieldData;
        for (let dt of Object.keys(item)) {
          if (fieldData.includes("{$" + dt + "}")) {
            fieldData = fieldData.replaceAll("{$" + dt + "}", item[dt])
          }
        }
        option[fld.optionField] = fieldData;
        prevValue = fieldData;
      }
      option.item = item;
    }
    else if (props?.valueField) {
      option.label = item[props.labelField];
      option.value = item[props.valueField];
      option.item = item;
    } else {
      option.value = item;
      option.label = item;
    }
    options.push(option);
  });

  const validateInput = () => {
    setFocus(false);
    allValidations();
  }

  const validateMandatory = () => {
    if ((!props?.value || props?.value === "")) {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
      }
      return props.label + " is mandatory";
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp?.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props?.setMandatoryFields && props?.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  // const validateSpecialCharacters = (value) => {
  //   if (specialCharacterRegex.test(value)) {
  //     return props.label + " must not contain special characters";
  //   }
  //   return "";
  // };




  const allValidations = () => {
    let errorMsg = "";
  
    const setError = (message) => {
      props?.setError((prev) => ({ ...prev, [props?.name]: message }));
    };
  
    if (props?.required && !props?.readOnly) {
      errorMsg = validateMandatory();
    }
  
    if (errorMsg) {
      setError(errorMsg);
      return;
    } else {
      setError("");
    }
  
    if (props?.value && props?.value !== "") {
      if (props.hasOwnProperty("isAlphanumericWithoutSpace") && !alphanumericWithoutSpaceRegex.test(props?.value)) {
        setError(`${props?.label} must be alphanumeric without space`);
      } else {
        setError("");
      }
  
      // errorMsg = validateSpecialCharacters(props?.value);
      // if (errorMsg) {
      //   setError(errorMsg);
      // } else {
      //   setError("");
      // }
  
      if (props?.customValidation) {
        errorMsg = props?.customValidation(props?.value, props?.name);
      }
    }
  
    setError(errorMsg);
  };
  


  useEffect(() => {
    if (props?.required && !props.value && !props.mandatoryFields?.includes(props.name)) {
      props?.setMandatoryFields && props?.setMandatoryFields((prev) => ([...prev, props.name]));
    }
  }, []);


  useEffect(() => {
    if (props?.submit) {
      props?.setFieldCount((prev) => ([...prev, props?.name]));
      allValidations();
    }
  }, [props?.submit]);

  return (
    <Form.Group className={`g-input-select`}>
      <Select
        {...props}
        classNamePrefix="select"
        className={` ${props.error && props.error[props.name] ? "text-field-with-error" : ""}`}
        options={options}
        blurInputOnSelect={false}
        onBlur={(e) => { validateInput(); }}
        value={props.value ? { label: props.value, value: props.value } : {}}
        isDisabled={props.disabled}
        placeholder=""
        inputId={props.name}
        onFocus={
          () => { setFocus(true) }}
        onChange={(opt) => {
          let obj = { target: { name: props.name, value: opt.value, item: opt.item } }
          props.onChange(obj);
        }}
      />
      <Form.Label className={`${(focus || (props?.value && props?.value !== "")) ? "active" : ""} ${props.error && props.error[props.name] ? "text-label-with-error" : ""}`} htmlFor={props.name}>
        {props.label}
        {props.label=="UOM" || props.label=="Location" || props.label=="Division" && <span className="req-input">*</span>}
        {(props.optional === true) && <span className="optional"> (optional)</span>}
      </Form.Label>
      {props.error && props.error[props.name] && (
        <Form.Text className="text-danger">
          {props.error[props.name]}
        </Form.Text>
      )}
    </Form.Group>
  );
}
